<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-08 23:33:24
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-01-23 17:47:55
 * @FilePath: /lobby/src/components/ChangeLanguage.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="change-language flex row center">
    <!-- <select v-model="selectLanguage">
      <option v-for="(item, index) in languages" :key="index" :value="item.code">
        {{ item.name }}
      </option>
    </select> -->
    <van-popover
      v-model:show="showPopover"
      :actions="
        country == 'ET'
          ? languagesET
          : country == 'CI'
            ? languagesCI
            : country == 'TZ'
              ? languagesTZ
              : languagesKE
      "
      :show-arrow="false"
      theme="dark"
      placement="left-start"
      @select="onSelect"
    >
      <template #reference>
        <div class="btn">
          <!-- <img :src="currentLanguage.icon" style="height: 0.4rem" /> -->
          {{ currentLanguage.lang }}&nbsp;<i
            :class="showPopover ? 'bi bi-chevron-up' : `bi bi-chevron-${arrow}`"
          ></i>
        </div>
      </template>
    </van-popover>
    <!-- <div>{{ `${currentLanguage.name} ${currentLanguage.code}` }}</div> -->
  </div>
</template>

<script>
import { config } from '@/common/config'
import { useLanguagesStore } from '@/stores/languages.js'
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  props: {
    arrow: {
      type: String,
      default: 'down'
    }
  },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      selectLanguage: null,
      showPopover: false,
      languagesCI: [],
      languagesET: [],
      languagesKE: [],
      languagesTZ: []
      // actions: [
      //   { text: 'Brazi', icon: `${config.resBaseUrl}flag_brazi.jpg` },
      //   { text: 'Ethiopia', icon: `${config.resBaseUrl}flag_ethiopia.jpg` },
      //   { text: 'Kenya', icon: `${config.resBaseUrl}flag_kenya.jpg` }
      // ],
    }
  },
  computed: {
    ...mapState(useLanguagesStore, ['languages', 'currentLanguage']),
    ...mapState(useUserStore, ['country'])
  },
  watch: {
    selectLanguage(newValue, oldValue) {
      console.log('selectLanguage', newValue, oldValue)
      if (newValue === oldValue) return
      this.setLanguage(newValue)
    }
  },
  mounted() {
    this.selectLanguage = this.currentLanguage.code
    this.languagesET = this.languages.filter((item) => {
      return item.code != 'fr' && item.code != 'sw'
    })
    this.languagesCI = this.languages.filter((item) => {
      return item.code == 'fr'
    })
    this.languagesKE = this.languages.filter((item) => {
      return item.code == 'en'
    })
    this.languagesTZ = this.languages.filter((item) => {
      return item.code == 'sw' || item.code == 'en'
    })
  },
  methods: {
    ...mapActions(useLanguagesStore, { setLanguage: 'setLanguage' }),
    onSelect(action) {
      console.log(action)
      this.selectLanguage = action.code
    }
  }
}
</script>

<style lang="scss" scoped>
.change-language {
  height: 0.8rem;
  font-size: 0.3rem;
  color: white;
  padding-left: var(--page-padding);
  padding-right: var(--page-padding);

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.select {
  background: rgba($color: #000000, $alpha: 0) !important;
  border-color: rgba($color: #000000, $alpha: 0) !important;
}

.van-popover--light {
  background: rgba($color: #000000, $alpha: 0) !important;
  background-color: rgba($color: #000000, $alpha: 0) !important;
}
.van-popover__arrow {
  background: rgba($color: #000000, $alpha: 0) !important;
  background-color: rgba($color: #000000, $alpha: 0) !important;
}
</style>
